const deleteCookie = (document: Document, cookie: string) => {
  const expiredDate = new Date(1970, 0, 1);
  document.cookie = `${cookie}=; expires=${expiredDate}; domain=.justgiving.com; path=/;`; // eslint-disable-line no-param-reassign
};
export default deleteCookie;
